import React, { useState, useEffect } from "react";
import { BsRulers } from "react-icons/bs";
import { AiFillCaretDown } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { Fade, Fade as Hamburger } from "hamburger-react";
import { GiTakeMyMoney } from "react-icons/gi";
import axios from "axios";
import { API_HOST } from "../api_utils";

function Header(props) {
  let navigate = useNavigate();
  const { userDataFromStorage } = props;
  const [showCashOption, setShowCashOption] = useState(false);
  const [showDbOption, setShowDbOption] = useState(false);
  const [showReportOption, setShowReportOption] = useState(false);
  const [showUserOption, setShowUserOption] = useState(false);
  const [customerOption, setCustomerOption] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [notifyLength, setNotifyLength] = useState(false);

  const [user, setUser] = useState([]);

  const { colorTheme } = props;

  // for color changing theme:

  const reportTabs = [
    {
      id: 1,
      name: "Cash Flow",
    },
    {
      id: 2,
      name: "Stamp/Claim Reports",
    },
    {
      id: 3,
      name: "Profit Reports",
    },
    {
      id: 4,
      name: "Profit Share Payments",
    },
    {
      id: 5,
      name: "My Stamp Duty",
    },
    {
      id: 6,
      name: "Duplicate Loans #",
    },
    {
      id: 7,
      name: "Defaulted Loans",
    },
    {
      id: 8,
      name: "Transaction Report",
    },
    {
      id: 9,
      name: "CNY Start Check",
    },
  ];

  // redirect to report routes as per user selection
  const redirectReportHandler = (data) => {
    if (data === 1) {
      navigate("/reports/cash_flow");
    } else if (data === 2) {
      navigate("/reports/stamp");
    } else if (data === 3) {
      navigate("/reports/profit_report");
    } else if (data === 4) {
      navigate("/reports/profit_share");
    } else if (data === 5) {
      navigate("/reports/my_stamp_duty");
    } else if (data === 6) {
      navigate("/reports/duplicate_loan");
    } else if (data === 7) {
      navigate("/reports/defaulted_loan");
    } else if (data === 8) {
      navigate("/reports/transaction_report");
    } else if (data === 9) {
      navigate("/reports/cny_check");
    }
  };

  const userData = JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
    if (!userData) {
      navigate("/");
    } else {
      setUser(userData);
    }
  }, []);

  const NotificationHandler = async () => {
    const { data } = await axios.get(`${API_HOST}/api/nickname_requests/`);
    if (!data.message) {
      setNotifyLength(true);
    } else {
      setNotifyLength(false);
    }
  };

  useEffect(() => {
    let user = JSON.parse(sessionStorage.getItem("user"));
    if (user?.user_role === "admin") {
      NotificationHandler();
    }
  }, []);

  return (
    <div
      style={{ backgroundColor: colorTheme }}
      className={
        window.location.pathname === "/"
          ? "hidden"
          : " xl:p-[0.5rem] lg:p-[0.7rem]  text-white font-Roboto transition duration-[0.6s]  fixed top-0 w-[100%] shadow-xl z-50"
      }>
      {/* Header for large screens  */}
      <div className="xl:flex justify-start space-x-8 lg:block  items-center hidden">
        <div
          onClick={() => navigate("/home")}
          className="flex items-center justify-start xl:space-x-2 lg:space-x-6 cursor-pointer ">
          <GiTakeMyMoney className="xl:text-[2.5rem] lg:text-[2rem]" />

          <p className="  font-[600] text-[1.5rem] tracking-wider">
            Microloan V1.0
          </p>
        </div>

        {window.location.pathname === "/login" ? (
          <div className=" flex-1 flex justify-end items-center">
            <div className="hover:border  flex items-center justify-center pr-[2rem] pl-[2rem] pt-[0.5rem] pb-[0.5rem]">
              <Link to={"/login"}>Login</Link>
            </div>
          </div>
        ) : (
          ""
        )}

        {/* {window.location.pathname === "/" ? (
          <div className=" flex-1 flex justify-end items-center">
            <div className="hover:border  flex items-center justify-center pr-[2rem] pl-[2rem] pt-[0.5rem] pb-[0.5rem]">
              <Link to={"/login"}>Get Started</Link>
            </div>
          </div>
        ) : (
          ""
        )} */}

        {/* ADMIN ACCESS HEADER TAB GROUP */}
        {window.location.pathname === "/" ||
        window.location.pathname === "/login" ? (
          ""
        ) : user.user_role === "admin" ? (
          <div className="grid grid-cols-12 xl:flex-grow xl:text-[1rem] lg:text-[0.8rem]  xl:pr-[0.5rem]">
            <div className="hover:border rounded-lg transition duration-[2s] col-span-1 h-[8vh] flex items-center justify-center ">
              <Link
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                to={"/home"}>
                Home
              </Link>
            </div>
            <div className="hover:border rounded-lg col-span-1 h-[8vh] flex items-center justify-center ">
              <Link
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                to={"/users"}>
                Users
              </Link>
            </div>
            <div className="hover:border rounded-lg col-span-1 h-[8vh] flex items-center justify-center ">
              <Link
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                to={"/products"}>
                Products
              </Link>
            </div>
            <div className="hover:border rounded-lg col-span-1 h-[8vh] flex items-center justify-center ">
              <Link
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                to={"/customers/overview"}>
                Customers
              </Link>
            </div>
            <div className="hover:border rounded-lg col-span-1 h-[8vh] flex items-center justify-center ">
              <Link
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                to={"/loans"}>
                Loans
              </Link>
            </div>
            <div className="hover:border rounded-lg col-span-1 h-[8vh] flex items-center justify-center ">
              <Link
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                to={"/start_of_day"}>
                Start of Day
              </Link>
            </div>
            <div className="hover:border col-span-1 h-[8vh] flex items-center justify-center ">
              <Link
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                to={"/claims"}>
                Claims
              </Link>
            </div>
            <div className="hover:border rounded-lg col-span-1 h-[8vh] flex items-center justify-center ">
              <Link
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                to={"/collections"}>
                Collections
              </Link>
            </div>
            <div className="hover:border rounded-lg col-span-1 h-[8vh] flex items-center justify-center relative">
              <p
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(!showCashOption);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                className="flex items-center justify-center cursor-pointer ">
                Cash{" "}
                <strong>
                  <AiFillCaretDown />
                </strong>
              </p>
              {showCashOption ? (
                <p className="absolute bottom-[-13vh] bg-white text-gray-600 flex items-center justify-between   flex-col w-[8rem] h-[6rem] rounded-lg shadow-2 z-20">
                  <span
                    onClick={() => {
                      setShowCashOption(false);
                      navigate("/cash/cash_count");
                    }}
                    className="border w-[100%] h-[50%] rounded-t-lg flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer">
                    Cash +/-
                  </span>
                  <span
                    onClick={() => {
                      setShowCashOption(false);
                      navigate("/cash/cash_start");
                    }}
                    className="border w-[100%] h-[50%] rounded-b-lg flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer">
                    Cash Start
                  </span>
                </p>
              ) : (
                ""
              )}
            </div>
            <div className="hover:border rounded-lg col-span-1 h-[8vh] flex items-center justify-center ">
              <Link
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                to={"/logs"}>
                Logs
              </Link>
            </div>
            <div className="hover:border rounded-lg col-span-1 h-[8vh] flex items-center justify-center relative">
              {/* <Link onClick={() => setShowCashOption(false)} to={'/db_actions'}>Db Actions</Link> */}
              <p
                onClick={() => {
                  setShowDbOption(!showDbOption);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                }}
                className="flex items-center justify-center cursor-pointer ">
                Db Actions{" "}
                <strong>
                  <AiFillCaretDown />
                </strong>
              </p>
              {showDbOption ? (
                <p className="absolute bottom-[-13vh] bg-white text-gray-600 flex items-center justify-between   flex-col w-[8rem] h-[6rem] rounded-lg shadow-2 z-20">
                  <span
                    onClick={() => {
                      setShowDbOption(false);
                      navigate("/db_actions/clear_db");
                    }}
                    className="border w-[100%] h-[50%] rounded-t-lg flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer">
                    Clear Db
                  </span>
                  <span
                    onClick={() => {
                      setShowDbOption(false);
                      navigate("/db_actions/import_basics");
                    }}
                    className="border w-[100%] h-[50%] rounded-b-lg flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer">
                    Import Basics
                  </span>
                </p>
              ) : (
                ""
              )}
            </div>
            <div className="hover:border rounded-lg col-span-1  flex items-center justify-center relative ">
              <p
                onClick={() => {
                  setShowReportOption(!showReportOption);
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowUserOption(false);
                }}
                className="flex items-center justify-center cursor-pointer ">
                Reports{" "}
                <strong>
                  <AiFillCaretDown />
                </strong>
              </p>
              {showReportOption ? (
                <p className="absolute bottom-[-22rem] right-[0.2rem] bg-white text-gray-600 flex items-center justify-between w-[12rem]   flex-col  rounded-lg shadow-2 z-20">
                  {reportTabs.map((x, index) => (
                    <span
                      onClick={() => {
                        setShowReportOption(false);
                        redirectReportHandler(x.id);
                      }}
                      className={
                        index === 0
                          ? "border-b w-[100%] h-[2.5rem] rounded-t-lg flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer "
                          : index === 8
                          ? " w-[100%] h-[2.5rem] rounded-b-lg flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer"
                          : " w-[100%] h-[2.5rem] border-b  flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer"
                      }>
                      {x.name}
                    </span>
                  ))}
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        {/* HOME BUTTON FOR OTHER USER ROLE  */}
        {window.location.pathname === "/" ||
        window.location.pathname === "/login" ? (
          ""
        ) : user.user_role === "admin" ? (
          ""
        ) : (
          <div className="flex justify-between items-center flex-1 ">
            <div className="hover:border rounded-lg  transition duration-[1s]  px-[4rem] h-[8vh] flex items-center justify-center ">
              <Link to={"/home"}>Home</Link>
            </div>

            {/* USER DROPDOWN , LOGOUT/USER SETTINGS (FOR REMAINING SCREEN) */}
            <div className=" lg:flex lg:text-[0.8rem] xl:text-[1rem] items-center justify-end px-[1rem] font-Roboto relative hidden ">
              <p
                onClick={() => {
                  setShowUserOption(!showUserOption);
                }}
                className="hover:border rounded-lg h-[8vh] p-[0.5rem] flex items-center justify-center cursor-pointer ">
                {user.login_name}
                <strong>
                  <AiFillCaretDown />
                </strong>
              </p>
              {showUserOption ? (
                <p className="absolute  xl:bottom-[-15vh] lg:bottom-[-15vh] 2xl:bottom-[-14vh] bg-white text-gray-600 flex items-center justify-between   flex-col w-[8rem] h-[6rem] rounded-lg shadow-2">
                  <span
                    onClick={() => {
                      setShowUserOption(false);
                      navigate("/my_settings");
                    }}
                    className="border w-[100%] h-[50%] rounded-t-lg flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer">
                    My Settings
                  </span>
                  <span
                    onClick={() => {
                      setShowUserOption(false);
                      sessionStorage.removeItem("user");
                      navigate("/");
                      window.location.reload();
                    }}
                    className="border w-[100%] h-[50%] rounded-b-lg flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer">
                    Logout
                  </span>
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
        )}
      </div>

      {/* USER DROPDOWN , LOGOUT/USER SETTINGS (FOR ADMIN SCREEN) */}
      {window.location.pathname === "/" ||
      window.location.pathname === "/login" ? (
        ""
      ) : user.user_role === "admin" ? (
        <div className="mt-[1%] lg:flex lg:text-[0.8rem] xl:text-[1rem] items-center justify-end px-[1rem] font-Roboto relative hidden ">
          <p
            onClick={() => {
              setShowUserOption(!showUserOption);
              setShowDbOption(false);
              setShowCashOption(false);
              setShowReportOption(false);
            }}
            className="hover:border rounded-lg h-[8vh] p-[0.5rem] flex items-center justify-center cursor-pointer ">
            {user.first_name}
            <strong>
              <AiFillCaretDown />
            </strong>
          </p>
          {showUserOption ? (
            <p className="absolute xl:bottom-[-15vh] lg:bottom-[-15vh] 2xl:bottom-[-14vh] bg-white text-gray-600 flex items-center justify-between   flex-col w-[8rem] h-[6rem] rounded-lg shadow-2">
              <span
                onClick={() => {
                  setShowUserOption(false);
                  navigate("/my_settings");
                }}
                className="border w-[100%] h-[50%] rounded-t-lg flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer">
                Notifications
                {notifyLength && (
                  <sup className="w-2 h-2 rounded-full bg-red-500 ml-2"></sup>
                )}
              </span>
              <span
                onClick={() => {
                  setShowUserOption(false);
                  sessionStorage.removeItem("user");
                  navigate("/");
                  window.location.reload();
                }}
                className="border w-[100%] h-[50%] rounded-b-lg flex items-center justify-center hover:bg-gray-300 transition duration-[0.6s] cursor-pointer">
                Logout
              </span>
            </p>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}

      {/*======================= HEADER FOR MOBILE and TAB============================= */}

      <div className="p-[0.5rem] flex justify-between items-center lg:hidden">
        <div className="flex justify-start items-center space-x-4">
          <GiTakeMyMoney className="text-[2rem]" />
          <p className="  font-[600] text-[1.2rem] tracking-widest">
            Microloan V1.0
          </p>
        </div>
        {window.location.pathname == "/" ||
        window.location.pathname == "/login" ? (
          ""
        ) : (
          <Fade toggled={isOpen} toggle={setOpen} />
        )}
      </div>

      {/* MOBILE AND TAB HEADER SCREENS FOR ADMIN */}
      {window.location.pathname === "/" ||
      window.location.pathname === "/login" ? (
        ""
      ) : user.user_role === "admin" ? (
        <div
          className={
            isOpen
              ? "p-[0.5rem] opacity-[100%] lg:hidden   transition duration-[0.8s] overflow-y-scroll h-screen"
              : "opacity-0 transition overflow-hidden h-0 p-[0.5rem] duration-[0.8s] lg:hidden overflow-y-scroll"
          }>
          <p
            onClick={() => {
              setShowDbOption(false);
              setShowCashOption(false);
              setShowReportOption(false);
              setShowUserOption(false);
              setOpen(false);
              navigate("/home");
            }}
            className="border-b border-t border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
            Home
          </p>
          {window.location.pathname === "/" ||
          window.location.pathname === "/login" ? (
            ""
          ) : (
            <>
              <p
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                  setOpen(false);
                  navigate("/users");
                }}
                className="border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
                Users
              </p>
              <p
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                  setOpen(false);
                  navigate("/products");
                }}
                className="border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
                Products
              </p>
              <p
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                  setOpen(false);
                  navigate("/customers/overview");
                }}
                className="border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
                Customers
              </p>
              <p
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                  setOpen(false);
                  navigate("/loans");
                }}
                className="border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
                Loans
              </p>
              <p
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                  setOpen(false);
                  navigate("/start_of_day");
                }}
                className="border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
                Start Of Day
              </p>
              <p
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                  setOpen(false);
                  navigate("/claims");
                }}
                className="border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
                Claims
              </p>
              <p
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                  setOpen(false);
                  navigate("/collections");
                }}
                className="border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
                Collections
              </p>
              <div className="border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem] overflow-y-scroll">
                <div
                  onClick={() => {
                    setShowDbOption(false);
                    setShowCashOption(!showCashOption);
                    setShowReportOption(false);
                    setShowUserOption(false);
                  }}
                  className="flex justify-start items-center space-x-1">
                  <p>Cash</p>
                  <AiFillCaretDown />
                </div>
                {showCashOption ? (
                  <p className=" flex items-center justify-between   flex-col ">
                    <span
                      onClick={() => {
                        setShowCashOption(false);
                        navigate("/cash/cash_count");
                        setOpen(false);
                      }}
                      className=" w-[100%] h cursor-pointer px-[4rem] border-b border-[#bc5a42] py-[0.5rem]">
                      Cash +/-
                    </span>
                    <span
                      onClick={() => {
                        setShowCashOption(false);
                        navigate("/cash/cash_start");
                        setOpen(false);
                      }}
                      className=" w-[100%] cursor-pointer px-[4rem]  py-[0.5rem]">
                      Cash Start
                    </span>
                  </p>
                ) : (
                  ""
                )}
              </div>
              <p
                onClick={() => {
                  setShowDbOption(false);
                  setShowCashOption(false);
                  setShowReportOption(false);
                  setShowUserOption(false);
                  setOpen(false);
                  navigate("/logs");
                }}
                className="border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
                Logs
              </p>
              <div className="border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
                <div
                  onClick={() => {
                    setShowDbOption(!showDbOption);
                    setShowCashOption(false);
                    setShowReportOption(false);
                    setShowUserOption(false);
                  }}
                  className="flex justify-start items-center space-x-1">
                  <p>Db Actions</p>
                  <AiFillCaretDown />
                </div>
                {showDbOption ? (
                  <p className=" flex items-center justify-between   flex-col ">
                    <span
                      onClick={() => {
                        setShowDbOption(false);
                        navigate("/db_actions/clear_db");
                        setOpen(false);
                      }}
                      className=" w-[100%] px-[4rem]  cursor-pointer border-b border-[#bc5a42] py-[0.5rem]">
                      Clear Db
                    </span>
                    <span
                      onClick={() => {
                        setShowDbOption(false);
                        navigate("/db_actions/import_basics");
                        setOpen(false);
                      }}
                      className=" w-[100%] px-[4rem] cursor-pointer  py-[0.5rem]">
                      Import Basics
                    </span>
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div
                className={
                  showReportOption
                    ? "border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem] pb-[6rem] overflow-y-scroll"
                    : "border-b  border-[#bc5a42] py-[0.7rem] px-[0.5rem] overflow-y-scroll"
                }>
                <div
                  onClick={() => {
                    setShowReportOption(!showReportOption);
                    setShowDbOption(false);
                    setShowCashOption(false);
                    setShowUserOption(false);
                  }}
                  className="flex justify-start items-center space-x-1">
                  <p>Reports</p>
                  <AiFillCaretDown />
                </div>

                {showReportOption ? (
                  <p className=" flex items-center justify-between flex-col  rounded-lg ">
                    {reportTabs.map((x, index) => (
                      <span
                        onClick={() => {
                          setShowReportOption(false);
                          redirectReportHandler(x.id);
                          setOpen(false);
                        }}
                        className={
                          index !== reportTabs.length - 1
                            ? "border-b border-[#bc5a42] py-[0.5rem] w-[100%] px-[4rem] cursor-pointer "
                            : " py-[0.5rem] px-[4rem] w-[100%]  cursor-pointer "
                        }>
                        {x.name}
                      </span>
                    ))}
                  </p>
                ) : (
                  ""
                )}
              </div>
              <p
                onClick={() => {
                  setShowUserOption(false);
                  navigate("/login");
                  setOpen(false);
                }}
                className=" py-[0.7rem] px-[0.5rem]">
                Logout
              </p>
            </>
          )}
        </div>
      ) : (
        ""
      )}

      {/* MOBILE AND TAB HEADER SCREENS FOR OTHER USER ROLES */}
      {window.location.pathname === "/" ||
      window.location.pathname === "/login" ? (
        ""
      ) : user.user_role === "admin" ? (
        ""
      ) : (
        <div
          className={
            isOpen
              ? "p-[0.5rem] opacity-[100%] lg:hidden   transition duration-[0.8s] overflow-y-scroll h-screen"
              : "opacity-0 transition overflow-hidden h-0 p-[0.5rem] duration-[0.8s] lg:hidden overflow-y-scroll"
          }>
          <p
            onClick={() => {
              setShowUserOption(false);
              setOpen(false);
              navigate("/home");
            }}
            className="border-b border-t border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
            Home
          </p>

          <p
            onClick={() => {
              setShowUserOption(false);
              setOpen(false);
              navigate("/login");
            }}
            className="border-b border-t border-[#bc5a42] py-[0.7rem] px-[0.5rem]">
            Logout
          </p>

          {/* <div className="py-[0.7rem] px-[0.5rem] flex justify-start items-center space-x-1">
            <p
              onClick={() => {
                setShowUserOption(!showUserOption);
                setShowDbOption(false);
                setShowCashOption(false);
                setShowReportOption(false);
              }}>
              {user.full_name}
            </p>
            <AiFillCaretDown />
          </div> */}
          {/* {showUserOption ? (
            <p className=" flex items-center justify-between   flex-col ">
              <span
                onClick={() => {
                  setShowUserOption(false);
                  navigate("/my_settings");
                  setOpen(false);
                }}
                className=" w-[100%] px-[4rem] cursor-pointer border-b border-[#bc5a42] py-[0.5rem]">
                Notifications
                {notifyLength && (
                  <sup className="w-2 h-2 rounded-full bg-red-500 ml-2"></sup>
                )}
              </span>
              <span
                onClick={() => {
                  setShowUserOption(false);
                  navigate("/");
                  setOpen(false);
                }}
                className=" w-[100%] px-[4rem] cursor-pointer border-b border-[#bc5a42] py-[0.5rem]">
                Logout
              </span>
            </p>
          ) : (
            ""
          )} */}
        </div>
      )}
    </div>
  );
}

export default Header;
